var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2591 16.0022C17.5503 14.5344 18.3334 12.6088 18.3334 10.5003C18.3334 5.89795 14.6025 2.16699 10.0001 2.16699C7.89158 2.16699 5.96598 2.95007 4.49824 4.24126L16.2591 16.0022ZM15.4993 16.7617C14.0319 18.0515 12.1073 18.8337 10.0001 18.8337C5.39771 18.8337 1.66675 15.1027 1.66675 10.5003C1.66675 8.39308 2.4489 6.46851 3.73872 5.00109L15.4993 16.7617Z",
    fill: "#B32542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/AlertError.0a4494ffb9dac42abe9401dd5f04b466.svg";
export { ForwardRef as ReactComponent };